import type { FunctionComponent } from 'react'
import { Badge } from '@which/seatbelt'

import styles from './FreeMembershipBadge.module.scss'
import { useShouldShowFreeMembershipBadge } from './hooks/useShouldShowFreeMembershipBadge'

type Props = {
  articleFreeMembershipStatus: string | null
}

export const FreeMembershipBadge: FunctionComponent<Props> = ({ articleFreeMembershipStatus }) => {
  const shouldShow = useShouldShowFreeMembershipBadge({ articleFreeMembershipStatus })

  if (!shouldShow) {
    return null
  }

  return (
    <div className={styles.badgeWrapper}>
      <Badge theme={'free member'} text="article" />
    </div>
  )
}
